import { Injectable } from '@angular/core';
import { ProductIntersection } from '@app/core/interfaces';
import * as fromMyZone from '@app/store/my-zone/my-zone';
import * as productActions from '@app/store/my-zone/product/product.actions';
import { select, Store } from '@ngrx/store';
import { NotificationInterface } from 'outshared-lib';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import {
    allProductsLoaded,
    getActiveCaravans,
    getActiveCars,
    getActiveMoped,
    getActiveMotors,
    getActiveProducts,
    getDetailLoaded,
    getInternationalMotorInsuranceCardCar,
    getNotifications,
    getProductCollection,
    getProductEntities,
    getSelectedProduct,
    getToCancelProducts,
    getTransferProducts,
    isProductLoaded,
} from './product.selectors';

/** @deprecated use outshared-lib - InsurancePolicyDataService */
@Injectable({ providedIn: 'root' })
export class ProductSelectorService {

    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public isProductLoaded$: Observable<boolean> = this.store.pipe(select(isProductLoaded));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getSelectedProduct$: Observable<ProductIntersection> = this.store.pipe(select(getSelectedProduct));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getProductEntities$: Observable<{ [id: string]: ProductIntersection }> =
        this.store.pipe(select(getProductEntities));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getDetailLoaded$: Observable<{ [id: string]: boolean }> = this.store.pipe(select(getDetailLoaded));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getProductCollection$: Observable<ProductIntersection[]> = this.store.pipe(select(getProductCollection));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getToCancelProducts$: Observable<ProductIntersection[]> = this.store.pipe(select(getToCancelProducts));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getInternationalMotorInsuranceCardCar$: Observable<ProductIntersection[]> =
        this.store.pipe(select(getInternationalMotorInsuranceCardCar));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getActiveCars$: Observable<ProductIntersection[]> = this.store.pipe(select(getActiveCars));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getActiveMoped$: Observable<ProductIntersection[]> = this.store.pipe(select(getActiveMoped));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getActiveMotors$: Observable<ProductIntersection[]> = this.store.pipe(select(getActiveMotors));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getActiveCaravans$: Observable<ProductIntersection[]> = this.store.pipe(select(getActiveCaravans));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getTransferProducts$: Observable<ProductIntersection[]> = this.store.pipe(select(getTransferProducts));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getActiveProducts$: Observable<ProductIntersection[]> = this.store.pipe(select(getActiveProducts));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public allProductsLoaded$: Observable<boolean> = this.store.pipe(select(allProductsLoaded));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getAllNotifications$: Observable<NotificationInterface[]> = this.store.pipe(select(getNotifications));

    constructor(private store: Store<fromMyZone.State>) {}

    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public clearNotifications(): void {
        this.getAllNotifications$
            .pipe(take(1), filter((errors) => errors.length > 0))
            .subscribe(() => this.store.dispatch(new productActions.ClearNotifications()));
    }
}
